import Image from 'next/image';
import DatabaseIcon from '../../public/svg/database.svg';
import WebappIcon from '../../public/svg/webapp.svg';
import PaintIcon from '../../public/svg/paint.svg';
import ProcessIcon from '../../public/svg/process.svg';
import dashboard from '../../public/real-estate/expertise/dashboard.png';
import styles from './real-estate-dashboard.module.css';

import {
  ComponentsDelivered,
  ContainerFluid,
  Htag,
  HtagVariant,
  Paragraph,
} from '../../components';

export default function RealEstateDashboard() {
  return (
    <section className={styles.dashboard}>
      <ContainerFluid className={styles.container}>
        <div className={styles.dashboard_inner}>
          <div className={styles.dashboard_start}>
            <Htag
              tag="h3"
              variant={HtagVariant.h3}
              className={styles.dashboard_title}
            >
              Landlords administration
            </Htag>
            <Paragraph className={styles.dashboard_text}>
              This property management dashboard is created to provide its
              owners with the status reports of their properties at any given
              time. They could use the app to collect the statistics about the
              properties, when rent is due and check the advanced analytics of
              their business.
            </Paragraph>
            <ComponentsDelivered
              title="Components delivered:"
              data={[
                {
                  id: 1,
                  Icon: ProcessIcon,
                  text: 'Creation of the new logic and process automation',
                },
                {
                  id: 2,
                  Icon: PaintIcon,
                  text: 'UX/UI design',
                },
                {
                  id: 3,
                  Icon: DatabaseIcon,
                  text: 'Database integration',
                },
                {
                  id: 4,
                  Icon: WebappIcon,
                  text: 'Web app',
                },
              ]}
            />
          </div>
          <div className={styles.dashboard_end}>
            <Image
              alt="LANDLORDS ADMINISTRATION"
              src={dashboard}
              width={1079}
              height={718}
            />
          </div>
        </div>
      </ContainerFluid>
    </section>
  );
}
